const htmlDecode = input => {
  if (!input || input.length === 0) return '';
  const e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes[0].nodeValue;
};

export default htmlDecode;
